module.exports = __webpack_public_path__ + "static/img/CEE2.57070764.jpg";